<h2 mat-dialog-title>{{'COLABORADORES.ACCIONESUSUARIO.TITULO' | translate}}</h2>
<mat-dialog-content class="mat-typography">
    <ng-container *ngIf="!datosColaborador; else cargado;">
        <div fxLayout="column" fxLayoutAlign="start center" class="p-20">
            <p>{{'COLABORADORES.ACCIONESUSUARIO.CARGANDO' | translate}}</p>
            <mat-spinner class="m-20" *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
        </div>
    </ng-container>
    <ng-template #cargado>
      <p>{{'COLABORADORES.ACCIONESUSUARIO.SUBTITULO' | translate}} {{datos.datosColab.name}}</p>
      <mat-list>
        <mat-list-item *ngFor="let accion of acciones; last as last">
          <mat-icon mat-list-icon>keyboard_arrow_right</mat-icon>
          <h4 mat-line>{{'COLABORADORES.ACCIONESUSUARIO.LISTA.' + accion.id | translate}}</h4>
          <button mat-mini-fab color="primary" class="m-5" [disabled]="accion.bloqueado" (click)="this[accion.funcion]()">
            <mat-icon>{{accion.icono}}</mat-icon>
          </button>
          <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
        </mat-list-item>
      </mat-list>
    </ng-template>
</mat-dialog-content>
<div mat-dialog-actions align="end">
  <button mat-raised-button color="accent" class="mt-20" (click)="salir()">
    {{'COLABORADORES.SENDGRID.BOTONES.BACK' | translate}}
    <mat-icon class="ml-20">arrow_back</mat-icon>
  </button>
</div>
